import { RequestHelper } from 'utils';
import { API_ROUTES } from 'utils/constants';

const getOptions = () => RequestHelper.GET(API_ROUTES.APPLICATION_ROLE);

export const ApplicationRolesService = {
  getOptions
};
